"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSwipeContainer = exports.StyledSwipeContainerChildren = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var Icon_1 = __importDefault(require("./Icon"));
var GrClose_1 = require("@react-icons/all-files/gr/GrClose");
var SwipeContainer = function (_a) {
    var show = _a.show, children = _a.children, close = _a.close, className = _a.className;
    return ((0, jsx_runtime_1.jsx)(material_1.Slide, __assign({ direction: "left", in: show, className: "twap-swipe-container ".concat(className) }, { children: (0, jsx_runtime_1.jsxs)(exports.StyledSwipeContainer, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ onClick: close, className: "twap-close" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: (0, jsx_runtime_1.jsx)(GrClose_1.GrClose, { style: { width: 20, height: 20 } }) }) })), (0, jsx_runtime_1.jsx)(exports.StyledSwipeContainerChildren, { children: children })] }) })));
};
exports.default = SwipeContainer;
exports.StyledSwipeContainerChildren = (0, system_1.styled)(system_1.Box)({
    width: "100%",
    height: "100%",
    overflow: "auto",
});
exports.StyledSwipeContainer = (0, system_1.styled)(system_1.Box)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    padding: "40px 10px 10px 10px",
    ".twap-close": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        border: "unset",
        background: "unset",
        top: 10,
        right: 10,
        position: "absolute",
        cursor: "pointer",
    },
});
